export default __webpack_public_path__ + "static/media/tradeIcon.ab5e32a7.svg";